import { mergeJSONData } from '@sahinyazilim/sahinyazilim-components';
import { Payment } from 'account/payment/model/payment';
import { plans } from './Plans.data';
import { NullUndefined } from 'common/model/NullUndefined';

export const findActivePlan = (
  payments: NullUndefined<Payment[]>,
): Payment | null => {
  if (!payments || payments.length === 0) {
    return null;
  }

  // PENDING ödemeleri kontrol et (3 günlük süre)
  const pendingPayments = payments.filter(
    (payment) => payment.status === 'PENDING',
  );
  const validPendingPayment = pendingPayments.find((payment) => {
    const createdAt = new Date(payment.createdAt);
    const threeDaysLater = new Date(createdAt);
    threeDaysLater.setDate(threeDaysLater.getDate() + 3);
    return new Date() <= threeDaysLater;
  });

  if (validPendingPayment) {
    // PENDING ödeme için usingStatus'u ACTIVED olarak ayarla
    return {
      ...validPendingPayment,
      usingStatus: 'ACTIVED',
    };
  }

  // Başarılı ödemeleri filtrele ve tarihe göre sırala (en yeni önce)
  const successfulPayments = payments
    .filter((payment) => payment.status === 'SUCCESS')
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );

  if (successfulPayments.length === 0) {
    return null;
  }

  // Her ödeme için plan bitiş tarihini ve grace period'u hesapla
  const paymentsWithEndDate = successfulPayments.map((payment) => {
    const startDate = new Date(payment.createdAt);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + Number(payment.quantity));

    // Grace period: Plan bitiş tarihinden 1 ay sonra
    const gracePeriodEnd = new Date(endDate);
    gracePeriodEnd.setMonth(gracePeriodEnd.getMonth() + 1);

    const now = new Date();
    const isActive = now <= endDate;
    const isInGracePeriod = now > endDate && now <= gracePeriodEnd;
    const isExpired = now > gracePeriodEnd;

    return {
      ...payment,
      planEndDate: endDate,
      gracePeriodEnd,
      isActive,
      isInGracePeriod,
      isExpired,
      usingStatus: isActive ? 'ACTIVED' : isInGracePeriod ? 'EXPIRED' : 'FREE',
    };
  });

  // Önce aktif plani bul
  const activePlan = paymentsWithEndDate.find((payment) => payment.isActive);

  if (activePlan) {
    // Frontend plan verilerini merge et
    const fePlan = plans.find((item) => item.id === activePlan.plan.id);
    if (fePlan) {
      activePlan.plan = mergeJSONData(activePlan.plan, fePlan);
    }
    return activePlan;
  }

  // Aktif plan yoksa, grace period'da olan plani bul
  const gracePeriodPlan = paymentsWithEndDate.find(
    (payment) => payment.isInGracePeriod,
  );

  if (gracePeriodPlan) {
    // Frontend plan verilerini merge et
    const fePlan = plans.find((item) => item.id === gracePeriodPlan.plan.id);
    if (fePlan) {
      gracePeriodPlan.plan = mergeJSONData(gracePeriodPlan.plan, fePlan);
    }
    return gracePeriodPlan;
  }

  // Grace period da bittiyse null döndür (FREE plan)
  return null;
};
